module.exports = __webpack_public_path__ + "static/media/richard.7cf63282.jpg";